import { useDocumentTitle } from "usehooks-ts";

const appTitle = import.meta.env.VITE_APP_TITLE || "mDoc CompleteHealth™";

const usePageTitle = (pageTitle?: string) => {
  const title = pageTitle ? `${pageTitle} | ${appTitle}` : appTitle;

  useDocumentTitle(title);
};

export default usePageTitle;
